import {IShowRealityCheckOptions} from "../reality-check-presenter.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {IToastHandler} from "../../../../toaster/toaster.service.interface";
import {RealityCheckToastPresenterBase} from "../reality-check-toast-presenter-base";

export class RomaniaRealityCheckPresenter extends RealityCheckToastPresenterBase {


    protected async _showToast(options: IShowRealityCheckOptions, onToastClosed: () => void): Promise<IToastHandler | null> {
        const sessionTimer = this.services.sessionTimer.currentSessionTimer;

        const subTitleText = this.services.translation.translate('INTERVAL_REMINDER_BODY', {
            hours: sessionTimer.days * 24 + sessionTimer.hours,
            minutes: sessionTimer.minutes
        });

        const toastId = `romania_interval_reminder_message_${sessionTimer.totalMinutes}`;

        if(this.services.hybrid.isOnDemandStandAloneGameRunning()) {
            this.services.hybrid.showAlert(subTitleText);
            onToastClosed();
            return null;
        } else {
            return this.services.toaster.showAckStandardToast({
                id: toastId,
                toastOptions: {
                    timeout: TimeSpan.fromSeconds(15)
                },
                contentProps: {
                    title: this.services.translation.translate('INTERVAL_REMINDER_TITLE'),
                    message: subTitleText
                },
                onToastShown: () => {
                    this.services.analytics.sendAnalytics('romania_interval_reminder_toaster', 'displayed', 'toast opened');
                },
                onToastClosed: () => {
                    onToastClosed();
                }
            });
        }
    }

}